import { defineComponent as _defineComponent } from 'vue'
import PackingContents from "@/components/order/PackingContentsV2.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SkuAbandonModal',
  props: {
  orderItems: {
    type: Array
  }
},
  setup(__props) {



return { __sfc: true,PackingContents }
}

})